<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_success" v-if="alert_error_close_shop === true">{{ message_error_close_shop }}</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_add_delivery === true">เพิ่มเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_edit_delivery === true">แก้ไขเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_delete_delivery === true">ลบเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
    </v-slide-x-reverse-transition>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_summary_bf_cs">
                <img src="@/assets/icon-restaurant-pos-before.png">
            </div>
            <h2 class="title_summary_bf_cs">รายละเอียดปิดยอดหน้าร้าน</h2>
        </div>
        <v-btn class="grad-primary-bg size_title_summary_bf_cs white--text" height="50" width="20%" @click="$router.push('/closeretrospectall')">
            ย้อนกลับ
        </v-btn>
    </div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-form ref="form_close_shop" @submit.prevent="openEditCloseShop()">
            <div class="d-flex mb-3">
                <v-card width="30%" class="mr-1">
                    <div class="pa-3">
                        <h3>ยอดเงินที่ควรมี</h3>
                        <v-card class="mb-3" color="blue lighten-5">
                            <div class="pa-3 border_sale_summary_bf_cs">
                                <div class="text-center titlefont_summary_bf_cs">{{ Intl.NumberFormat().format(cash_payment) }}</div>
                                <div>เงินสด</div>
                            </div>
                        </v-card>
                        <v-card class="mb-3">
                            <div class="pa-3 border_sale_summary_bf_cs">
                                <div class="text-center titlefont_summary_bf_cs">{{ Intl.NumberFormat().format(transfer_payment) }}</div>
                                <div>เงินโอน</div>
                            </div>
                        </v-card>
                        <v-card class="mb-3">
                            <div class="pa-3 border_sale_summary_bf_cs">
                                <div class="text-center titlefont_summary_bf_cs">{{ Intl.NumberFormat().format(credit_payment) }}</div>
                                <div>เครดิต</div>
                            </div>
                        </v-card>
                        <v-card class="mb-3">
                            <div class="pa-3 border_sale_summary_bf_cs">
                                <div class="text-center titlefont_summary_bf_cs">{{ half_person ? Intl.NumberFormat().format(person_half) : 0 }}</div>
                                <div>โครงการ คนละครึ่ง</div>
                            </div>
                        </v-card>
                        <v-card class="mb-3">
                            <div class="pa-3 border_sale_summary_bf_cs">
                                <div class="text-center titlefont_summary_bf_cs">{{ blue_flag ? Intl.NumberFormat().format(blue_flag) : 0 }}</div>
                                <div>โครงการ ร้านธงฟ้า</div>
                            </div>
                        </v-card>
                    </div>
                </v-card>
                <v-card width="70%" class="ml-1">
                    <div class="pa-3">

                        <div class="d-flex">
                            <div class="half_summary_bf_cs mr-1">
                                <h3>เงินที่มี</h3>
                            </div>
                            <div class="half_summary_bf_cs ml-1">
                                <h3>ส่วนต่าง</h3>
                            </div>
                        </div>

                        <div class="d-flex mb-3">
                            <div class="half_summary_bf_cs mr-1">
                                <v-text-field label="เงินสด" type="number" v-model="cash" :rules="[v => !!v || 'กรุณากรอกเงินสด']" hide-details="auto" required outlined disabled></v-text-field>
                            </div>
                            <div class="half_summary_bf_cs ml-1 d-flex align-center">
                                เงินสดส่วนต่าง {{ Intl.NumberFormat().format(cash - cash_payment) }} บาท
                            </div>
                        </div>
                        <div class="d-flex mb-3">
                            <div class="half_summary_bf_cs mr-1">
                                <v-text-field label="เงินโอน" type="number" v-model="transfer" :rules="[v => !!v || 'กรุณากรอกเงินโอน']" hide-details="auto" required outlined disabled></v-text-field>
                            </div>
                            <div class="half_summary_bf_cs ml-1 d-flex align-center">
                                เงินโอนส่วนต่าง {{ Intl.NumberFormat().format(transfer - transfer_payment - credit_payment) }} บาท
                            </div>
                        </div>

                        <div class="d-flex mb-3">
                            <div class="half_summary_bf_cs mr-1">

                            </div>
                            <div class="half_summary_bf_cs ml-1">
                                <h4>
                                    เงินส่วนต่าง {{ Intl.NumberFormat().format((cash - cash_payment) + (transfer - transfer_payment - credit_payment)) }} บาท
                                </h4>
                            </div>
                        </div>
                        <div class="d-flex mb-3">
                            <div class="full_summary_bf_cs">
                                <v-text-field label="เหตุผล" v-model="description" hide-details="auto" outlined disabled></v-text-field>
                            </div>
                        </div>
                        <!-- <div class="text-center">
                            <v-btn color="#28ab28" class="title_font_add_team white--text" type="submit" width="50%" height="50">
                                ปิดร้าน
                            </v-btn>
                        </div> -->
                    </div>
                </v-card>
            </div>
            <div>
                <v-card>
                    <div class="pa-3">
                        <div class="d-flex justify-space-between align-center mb-2">
                            <h3>เดริเวอร์รี่</h3>
                            <!-- <v-btn height="50" width="20%" class="white--text color_blue_summary_before_close_shop" @click="openDeliveryAdd()">
                                เพิ่มเดริเวอร์รี่
                            </v-btn> -->
                        </div>

                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center border_header_summary_before_close_shop" width="30%">
                                        ชื่อ
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        ยอดขาย (บาท)
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        ส่วนลด (บาท)
                                    </th>

                                    <th class="text-center border_header_summary_before_close_shop">
                                        รายได้ก่อนหักค่าบริการ
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        ค่าบริการ และ Vat
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        รายได้สุทธิ
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        เงินรับเข้า
                                    </th>
                                    <th class="text-center border_header_summary_before_close_shop">
                                        รายได้ค้างรับ
                                    </th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr v-for="(delivery_input_detail,index) in delivery_input_list" :key="index">
                                    <td class="text-center border_header_summary_before_close_shop" width="30%">
                                        <div class="d-flex">
                                            <div>{{ delivery_input_detail.debtor_name }}</div>
                                            <v-icon size="20" @click="detailDelivery(delivery_input_detail.id)">mdi-pencil-box</v-icon>
                                            <v-icon size="20" @click="openConfirmDeleteDelivery(delivery_input_detail.id,delivery_input_detail.debtor_name)">mdi-delete</v-icon>
                                        </div>
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop pt-2 pb-2" width="15%">
                                        <!-- <div>
                                            <v-text-field v-model="delivery_input_detail.sale" type="number" @keyup="delivery_input(delivery_input_detail.id)" :rules="[v => !!v || 'กรุณากรอกยอดขาย']" required hide-details="auto" dense outlined></v-text-field>
                                        </div> -->
                                        {{ delivery_input_detail.sale }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop pt-2 pb-2" width="15%">
                                        <!-- <div>
                                            <v-text-field v-model="delivery_input_detail.discount" type="number" @keyup="delivery_input(delivery_input_detail.id)" :rules="[v => !!v || 'กรุณากรอกส่วนลด']" required hide-details="auto" dense outlined></v-text-field>
                                        </div> -->
                                        {{ delivery_input_detail.discount }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop">
                                        {{ delivery_input_detail.before_service ? currencyFormat(delivery_input_detail.before_service) : 0 }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop">
                                        {{ delivery_input_detail.service_charge_vat ? currencyFormat(delivery_input_detail.service_charge_vat) : 0 }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop">
                                        {{ delivery_input_detail.net_income ? currencyFormat(delivery_input_detail.net_income) : 0 }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop">
                                        {{ delivery_input_detail.price }}
                                    </td>
                                    <td class="text-center border_header_summary_before_close_shop">
                                        {{ delivery_input_detail.accrued_income ? currencyFormat(delivery_input_detail.accrued_income) : 0 }}
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td class="text-center border_header_summary_before_close_shop pt-2 pb-2" colspan="8">
                                        <v-btn color="#28ab28" class="title_font_add_team white--text" type="submit" width="20%" height="50">
                                            แก้ไขการปิดร้าน
                                        </v-btn>
                                    </td>
                                </tr> -->
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card>
            </div>
        </v-form>
        <!-- เพิ่มเดริเวอร์รี่ -->
        <v-dialog v-model="open_add_delivery" persistent max-width="600px">

            <v-card>
                <v-form ref="form_delivery_add" @submit.prevent="addDelivery()">
                    <v-card-title class="justify-space-between">
                        <div>
                            เพิ่มเดริเวอร์รี่
                        </div>
                        <div class="cursor_summary_before_close_shop" @click="open_add_delivery = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>

                                <v-col cols="12">
                                    <v-text-field label="ลูกหนี้" v-model="delivery_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']" required outlined></v-text-field>
                                    <v-text-field label="ค่าบริการ (%)" type="number" v-model="delivery_service" :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                                    <v-text-field label="VAT (%)" type="number" v-model="delivery_vat" :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                                    <div class="d-flex align-center mb-2">
                                        <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                                        <v-input-colorpicker v-model="delivery_color_code" class="colorpicker_summary_before_close_shop" />
                                    </div>
                                    <v-text-field label="รหัสสี" v-model="delivery_color_code" :rules="[v => !!v || 'กรุณาเลือกรหัสสี']" required outlined></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- แก้ไขเดริเวอร์รี่ -->
        <v-dialog v-model="open_edit_delivery" persistent max-width="600px">
            <div v-if="loading_edit_delivery_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_edit_delivery_page === false">
                <v-form ref="form_delivery_edit" @submit.prevent="editDelivery()">
                    <v-card-title class="justify-space-between">
                        <div>
                            แก้ไขเดริเวอร์รี่
                        </div>
                        <div class="cursor_summary_before_close_shop" @click="open_edit_delivery = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>

                                <v-col cols="12">
                                    <v-text-field label="ลูกหนี้" v-model="edit_delivery_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']" required outlined></v-text-field>
                                    <v-text-field label="ค่าบริการ (%)" type="number" v-model="edit_delivery_service" :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                                    <v-text-field label="VAT (%)" type="number" v-model="edit_delivery_vat" :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                                    <div class="d-flex align-center mb-2">
                                        <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                                        <v-input-colorpicker v-model="edit_delivery_color_code" class="colorpicker_summary_before_close_shop" />
                                    </div>
                                    <v-text-field label="รหัสสี" v-model="edit_delivery_color_code" :rules="[v => !!v || 'กรุณาเลือกรหัสสี']" required outlined></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- ยืนยันลบดริเวอร์รี่ -->
        <v-dialog v-model="open_confirm_delete_delivery" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>
                <v-card-text>
                    ต้องการลบเดริเวอร์รี่ {{ delete_delivery_name }} ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="deleteDelivery()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="closeConfirmDeliveryDelete()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="open_close_shop" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span>ปิดร้าน</span>
                </v-card-title>

                <v-card-text>
                    <div>ต้องการปิดรอบลิ้นชักวันนี้ใช่หรือไม่ ?</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text titlefont_summary_bf_cs" @click="editCloseShop()" height="50">
                        ปิดรอบ
                    </v-btn>
                    <v-btn color="error" class="titlefont_summary_bf_cs" height="50" @click="open_close_shop = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import {
    currencyFormat
} from '@/helper/numberformat.js'
import assignrelevantpeopleall from '@/api/account/accountsetting/assignrelevantpeopleall.js'
import InputColorPicker from 'vue-native-color-picker'
export default {
    name: 'summaryBeforeCloseShop',
    components: {
        "v-input-colorpicker": InputColorPicker,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            open_close_shop: false,
            alert_error_close_shop: false,
            message_error_close_shop: null,
            cash_payment: 0,
            credit_payment: 0,
            transfer_payment: 0,
            person_half: 0,
            blue_flag: 0,
            cash: null,
            transfer: null,
            description: null,
            delivery_input_list: [],
            open_add_delivery: false,
            alert_add_delivery: null,
            delivery_name: null,
            delivery_service: null,
            delivery_vat: null,
            delivery_color_code: null,
            open_edit_delivery: false,
            loading_edit_delivery_page: true,
            alert_edit_delivery: null,
            edit_delivery_id: null,
            edit_delivery_name: null,
            edit_delivery_service: null,
            edit_delivery_vat: null,
            edit_delivery_color_code: null,
            open_confirm_delete_delivery: false,
            alert_delete_delivery: false,
            delete_delivery_id: null,
            delete_delivery_name: null,
        }
    },
    methods: {
        currencyFormat,
        async closeRetrospectDetail() {
            this.loading_page = true
            this.delivery_input_list = []
            await HTTP.get('/listCloseStore/' + this.$store.state.detailCloseRetrospectId, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.cash_payment = parseFloat(response.data.detail.cash)
                        this.credit_payment = parseFloat(response.data.detail.cash_credit)
                        this.transfer_payment = parseFloat(response.data.detail.cash_transfer)
                        this.person_half = parseFloat(response.data.detail.person_half)
                        this.blue_flag = parseFloat(response.data.detail.blue_flag)

                        this.cash = response.data.detail.money_close
                        this.transfer = response.data.detail.trans_money_close
                        this.description = response.data.detail.reason
                        
                        response.data.delivery.forEach((detail) => {
                            const before_service = parseInt(detail.sale) + parseInt(detail.discount)
                            const service = parseInt(before_service) * parseInt(detail.service_charge) / 100
                            const service_charge_vat = (parseInt(before_service) * parseInt(detail.service_charge) / 100) + ((service * parseInt(detail.vat)) / 100)
                            const net_income = before_service - service_charge_vat
                            const accrued_income = net_income - detail.price
                            this.delivery_input_list.push({
                                id: detail.id,
                                debtor_name: detail.debtor_name,
                                sale: detail.sale,
                                discount: detail.discount,
                                price: detail.price,
                                service_charge: detail.service_charge,
                                vat: detail.vat,
                                before_service: before_service,
                                service_charge_vat: service_charge_vat,
                                net_income: net_income,
                                accrued_income: accrued_income,

                            })
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async delivery_input(id) {
            let delivery_detail = this.delivery_input_list.find((detail) => {
                return detail.id == id
            })
            if (delivery_detail.sale && delivery_detail.discount) {
                delivery_detail.before_service = parseInt(delivery_detail.sale) + parseInt(delivery_detail.discount)
                const service = parseInt(delivery_detail.before_service) * parseInt(delivery_detail.service_charge) / 100
                delivery_detail.service_charge_vat = (parseInt(delivery_detail.before_service) * parseInt(delivery_detail.service_charge) / 100) + ((service * parseInt(delivery_detail.vat)) / 100)
                delivery_detail.net_income = delivery_detail.before_service - delivery_detail.service_charge_vat
                delivery_detail.accrued_income = delivery_detail.net_income - delivery_detail.price
            }

        },
        async openEditCloseShop() {
            if (this.$refs.form_close_shop.validate()) {
                this.open_close_shop = true
            }
        },
        async editCloseShop() {
            this.loading_page = true
            this.open_close_shop = false
            let lost_cash_all = (this.cash - this.cash_payment) + (this.transfer - this.transfer_payment)
            let status = 1
            if (lost_cash_all < 0) {
                status = 0
                lost_cash_all = lost_cash_all * (-1)
            }

            let debtor_id = []
            let sale = []
            let discount = []
            let income_before_deductions = []
            let service_vat = []
            let total_price = []
            let income_price = []
            let price = []
            let accrued_income = []

            this.delivery_input_list.forEach((detail) => {
                debtor_id.push(detail.id)
                sale.push(detail.sale)
                discount.push(detail.discount)
                income_before_deductions.push(detail.before_service)
                service_vat.push(detail.service_charge_vat)
                total_price.push(detail.net_income)
                income_price.push(detail.price)
                price.push(detail.accrued_income)
                accrued_income.push(detail.accrued_income)
            })
            HTTP.post('/listCloseStore/update/' + this.$stroe.state.detailCloseRetrospectId, {
                    money: this.cash,
                    trans_money_close: this.transfer,
                    lost_cash: lost_cash_all,
                    status_lost: status,
                    reason: this.description,
                    debtor_id: debtor_id,
                    sale: sale,
                    discount: discount,
                    income_before_deductions: income_before_deductions,
                    service_vat: service_vat,
                    total_price: total_price,
                    income_price: income_price,
                    price: price,
                    accrued_income: accrued_income,
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                        this.$router.push('/closeretrospectall')
                    }
                    if (response.data.successful === false) {
                        this.message_error_close_shop = response.data.message
                        this.loading_page = false
                        this.alert_error_close_shop = true
                        setTimeout(() => this.alert_error_close_shop = false, 5000)

                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async openDeliveryAdd() {
            this.open_add_delivery = true
            this.delivery_name = null
            this.delivery_service = null
            this.delivery_vat = null
            this.delivery_color_code = null
        },
        async addDelivery() {
            if (this.$refs.form_delivery_add.validate()) {
                this.open_add_delivery = false
                this.loading_page = true

                const data = {
                    debtor_name: this.delivery_name,
                    service_charge: this.delivery_service,
                    vat: this.delivery_vat,
                    color_code: this.delivery_color_code,
                }

                assignrelevantpeopleall.addDebtor(data).then((response) => {
                    if (response.data.successful === true) {
                        this.closeRetrospectDetail()
                        this.alert_add_delivery = true
                        setTimeout(() => this.alert_add_delivery = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

                this.delivery_name = null
                this.delivery_service = null
                this.delivery_vat = null
            }
        },
        async detailDelivery(id) {
            this.loading_edit_delivery_page = true
            this.open_edit_delivery = true
            assignrelevantpeopleall.detailDebtor(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_delivery_id = response.data.debtor.id
                    this.edit_delivery_name = response.data.debtor.debtor_name
                    this.edit_delivery_service = response.data.debtor.service_charge
                    this.edit_delivery_vat = response.data.debtor.vat
                    this.edit_delivery_color_code = response.data.debtor.color_code
                    this.loading_edit_delivery_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editDelivery() {
            if (this.$refs.form_delivery_edit.validate()) {
                this.loading_edit_delivery_page = true
                this.open_edit_delivery = false
                this.loading_page = true

                const data = {
                    debtor_name: this.edit_delivery_name,
                    service_charge: this.edit_delivery_service,
                    vat: this.edit_delivery_vat,
                    color_code: this.edit_delivery_color_code,
                }

                assignrelevantpeopleall.editDebtor(this.edit_delivery_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.closeRetrospectDetail()
                        this.alert_edit_delivery = true
                        setTimeout(() => this.alert_edit_delivery = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
                this.edit_delivery_id = null
                this.edit_delivery_name = null
                this.edit_delivery_service = null
                this.edit_delivery_vat = null
                this.edit_delivery_color_code = null
            }
        },
        async openConfirmDeleteDelivery(id, name) {
            this.delete_delivery_id = id
            this.delete_delivery_name = name
            this.open_confirm_delete_delivery = true
        },
        async closeConfirmDeliveryDelete() {
            this.delete_delivery_id = null
            this.delete_delivery_name = null
            this.open_confirm_delete_delivery = false
        },
        async deleteDelivery() {
            this.loading_page = true
            this.open_confirm_delete_delivery = false
            assignrelevantpeopleall.deleteDebtor(this.delete_delivery_id).then((response) => {
                if (response.data.successful === true) {
                    this.delete_delivery_id = null
                    this.delete_delivery_name = null
                    this.closeRetrospectDetail()
                    this.alert_delete_delivery = true
                    setTimeout(() => this.alert_delete_delivery = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
    },
    mounted() {
        this.closeRetrospectDetail()
    }
}
</script>

<style scoped>
.border_header_summary_before_close_shop {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.color_blue_summary_before_close_shop {
    background: linear-gradient(to top, #158cba, #55c0e9);
}

.cursor_summary_before_close_shop {
    cursor: pointer;
}

.colorpicker_summary_before_close_shop {
    width: 25px;
}
</style>
